var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeliport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      width: 64,
      height: 64,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,0C114.842,0,0,114.842,0,256s114.842,256,256,256c141.158,0,256-114.842,256-256S397.158,0,256,0z  M256,447.72c-105.715,0-191.72-86.005-191.72-191.72S150.285,64.28,256,64.28S447.72,150.285,447.72,256 S361.715,447.72,256,447.72z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "302.397,153.888 302.557,239.21 209.603,239.37 209.443,153.728 169.414,153.888 169.574,358.272  209.603,358.112 209.443,274.797 302.114,274.641 302.397,274.641 302.557,358.272 342.586,358.272 342.426,153.728  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeliport);
export default __webpack_public_path__ + "static/media/heliport.e78df817.svg";
export { ForwardRef as ReactComponent };